import "./widgetLg.css";
import { useGetAllOrderQuery } from "../../../services/orderApi";
import { useNavigate } from "react-router-dom";
import { MdReceiptLong } from "react-icons/md";
import { AdminTable, AdminBadge, ORDER_STATUS_VARIANT } from "../../../components/ui";
import { formatDate } from "../../../utils/format";

export default function WidgetLg() {
  const { data, isLoading } = useGetAllOrderQuery();
  const navigate = useNavigate();

  const rows = (data || []).slice(-5).reverse();

  const columns = [
    {
      key: "order_Id",
      header: "Order",
      render: (o) => (
        <div className="widgetLgUser">
          <span className="widgetLgIcon"><MdReceiptLong /></span>
          <span>#{o.order_Id}</span>
        </div>
      ),
    },
    { key: "order_Placment_Date", header: "Date", render: (o) => formatDate(o.order_Placment_Date) },
    { key: "total_Amount", header: "Amount", render: (o) => `₹${Number(o.total_Amount).toFixed(2)}` },
    {
      key: "order_Status",
      header: "Status",
      render: (o) => <AdminBadge variant={ORDER_STATUS_VARIANT[o.order_Status] || "neutral"}>{o.order_Status}</AdminBadge>,
    },
  ];

  return (
    <div className="widgetLg">
      <h2 className="widgetLgTitle">Latest Orders</h2>
      <AdminTable
        columns={columns}
        rows={rows}
        rowKey={(o) => o.order_Id}
        isLoading={isLoading}
        pageSize={5}
        emptyIcon={<MdReceiptLong />}
        emptyTitle="No orders yet"
        onRowClick={(o) => navigate(`/admin/order/details/${o.order_Id}`)}
      />
    </div>
  );
}
